import { DataFieldType } from "src/types/data-field.types";
import { createNodeDef } from "../nodes.helpers";

export const joinNodeDef = createNodeDef({
  type: "join",
  displayName: "Join",
  description: "Joins a list of strings with a separator",
  acceptsChildren: true,
  initialData: () => ({ separator: ", " }),
  fields: [{ type: DataFieldType.TEXT, key: "separator", label: "Separator" }],
  generate: async ({ node, children }) => {
    const results: unknown[] = [];
    for await (const { value } of children.loop()) {
      results.push(typeof value === "object" ? JSON.stringify(value) : value);
    }

    return results.join(node.data.separator);
  },
});
